import React from "react";
import Chart from "react-apexcharts";

const defData = {
  options: {
    chart: {
      type: "bar",
      height: "500px",
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      },
    },
    theme: {
      mode: "dark",
      monochrome: {
        enabled: false,
        color: "#68bcbc",
        shadeTo: "dark",
        shadeIntensity: 1,
      },
    },
    title: {
      text: "Personas por Ocupación",
      align: "left",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "rgba(250, 250, 250, 0.8)",
      },
    },
    xaxis: {
      categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997],
    },
  },
  series: [
    {
      data: [30, 40, 45, 50, 49, 60, 70],
    },
  ],
};
const JobChart = ({ jobsList, personasList }) => {
  const [data, setData] = React.useState(defData);

  const processJobData = () => {
    const formattedData = {
      ...data,
    };
    formattedData.options = {
      ...data.options,
      ...{
        xaxis: { categories: jobsList.map((item) => item.ocupacion) },
      },
    };
    return formattedData;
  };
  
  React.useEffect(() => {
    let formattedData = {...processJobData()}

    formattedData = {
      ...formattedData,
      ...{
        series: [
          {
            data: formattedData.options.xaxis.categories.map(jobItem => {
              const jobObj = jobsList.find(item => item.ocupacion === jobItem)
              const personPerJobList = personasList.filter(person => person.ocupacion === jobObj.id);
              return personPerJobList.length
            }),
          },
        ],
      },
    }

    setData({...formattedData})

  }, [jobsList, personasList]);

  return (
    <Chart
      className="chart"
      options={data.options}
      series={data.series}
      type="bar"
      width="100%"
      height={"500px"}
    />
  );
};
export default JobChart;
